import React from 'react'
import {
  ResourceCard,
  ResourceInContent,
  ResourcesTitle,
  ResourcesDetail,
  AproveController,
} from './styled'
import { getGlobalState } from '../../store'
import Approve from './Approve'
import { Flex } from '@chakra-ui/core'
import Color from 'color'
import Actions from './Actions/'

const ResourceComponent = (props) => {
  const card = props.data
  const type = props.types ? props.types.find((t) => t._id === card.type) : {}
  const authors = getGlobalState('users')
  const author = authors ? authors.find((t) => t._id === card.author) : {}
  return (
    <ResourceCard approved={props.approved}>
      <ResourceInContent>
        <span
          style={{
            fontSize: '.7em',
            fontWeight: 'bold',
            background: type ? type.color : '',
            color:
              type && type.color
                ? Color(type.color).isLight()
                  ? '#000000'
                  : '#ffffff'
                : '',
          }}
          onClick={() =>
            props.onClick && props.onClick(props.data._id, 'resources')
          }
        >
          {card.code}
        </span>

        <div>
          <ResourcesTitle>
            <Flex style={{ justifyContent: 'space-between' }}>
              <div
                onClick={() =>
                  props.onClick && props.onClick(props.data._id, 'resources')
                }
              >
                {card.name}
              </div>
              {!props.simplified && author && (
                <div className="author" style={{ textAlign: 'right' }}>
                  {author.firstName}
                  {/* <i className={`icon-people icons`} /> */}
                </div>
              )}
            </Flex>
            <Actions
              type={'resorce'}
              column={props.column}
              data={card}
              relataion={props.data.relationId}
              project={props.project}
              bottom={props.bottom}
            />
          </ResourcesTitle>

          {type && (
            <ResourcesDetail className={'pickerOnly'}>
              {type.name}
            </ResourcesDetail>
          )}
        </div>
      </ResourceInContent>
      {props.approved === 'false' && (
        <Approve relationId={props.data.relationId} />
      )}
    </ResourceCard>
  )
}

export default React.memo(ResourceComponent, (prevProps, nextProps) => {
  return (
    prevProps.data._id === nextProps.data._id &&
    prevProps.approved === nextProps.approved &&
    prevProps.data.relStatus === nextProps.data.relStatus
  )
})
